import React, { Component } from "react";

import AddComment from "./components/add-comment";
import { Button } from "reactstrap";
import { withNamespaces } from "react-i18next";
import { Card, CardBody } from "reactstrap";

import { Services } from "./../../../../../../repositories/clients/Services";
import { Menu, Dropdown } from "antd";
import {
  MoreOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";

// import RestService from '../../../../../../services/restService';
import Table from "../../../../Components/Table";
import "./styles.scss";

import { FilterForRole } from "../../../../../Global/Permission/filter";
import { moduleActions } from "../../../../../Global/Permission/constants";

import Axios from "axios";
import { withRouter } from "react-router-dom";
import createModal from "../../../../Components/ModalV2";

// const rest = new RestService();
const size = "18px";
class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match ? this.props.match.params.id : -1,
      modal: false,
      openDeleteModal: false,
      comments: [],
      order: {},
      data: [],
      columns: [
        {
          label: this.props.t("actions"),
          key: "",
          custom: (value) => {
            const allowedDocCategoryIds = [21, 23, 24, 25];
            if (!allowedDocCategoryIds.includes(value.DocCategoryId)) return null;

            // const isOwner = Number(this.props._user) === Number(value.UserId);

            return (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div style={{ display: "inline-flex", alignItems: "center" }} className="container-options">
                        <CloudDownloadOutlined style={{ fontSize: size }} />
                        <a
                          style={{ color: "#000a2e", textDecoration: "none", fontWeight: "100" }}
                          href={value.URL}
                        >
                          <i style={{ marginLeft: "10px" }} className="global-text">
                            <span className="global-text" style={{ fontSize: "14px", fontStyle: "italic" }}>
                              {this.props.t("download")}
                            </span>
                          </i>
                        </a>
                      </div>
                    </Menu.Item>

                    {!this.props.isMobil && ![".docx"].includes(value.Type) && (
                      <Menu.Item
                        onClick={() => {
                          window.open(`${Services.ORDEN_SERV.path}orderDocument/document/view/pdf/?url=${value.URL}`);
                        }}
                      >
                        <div
                          style={{ display: "inline-flex", alignItems: "center", marginLeft: "-15px" }}
                          className="container-options"
                        >
                          <i
                            style={{ fontSize: "19px", marginLeft: "12px" }}
                            className="global-text icon-search"
                          >
                            <span
                              className="global-text"
                              style={{ fontSize: "14px", fontStyle: "italic", marginLeft: "4px" }}
                            >
                              {this.props.t("open")}
                            </span>
                          </i>
                        </div>
                      </Menu.Item>
                    )}

                    <FilterForRole
                      rol={parseInt(this.props._rolId)}
                      userId={parseInt(this.props._user)}
                      moduleAction={
                        moduleActions.DELETE_DOCUMENTS
                      }
                      userCreatedId={value.UserId}>
                      <Menu.Item onClick={() => this.rmDocument(value)}>
                        <div
                          style={{ display: "inline-flex", alignItems: "center", marginLeft: "-4px" }}
                          className="container-options"
                        >
                          <span style={{ fontSize: "18px" }} className="icon-delete global-text">
                            <span
                              className="global-text"
                              style={{ fontSize: "14px", fontStyle: "italic" }}
                            >
                              {this.props.t("eliminate")}
                            </span>
                          </span>
                        </div>
                      </Menu.Item>
                    </FilterForRole>
                  </Menu>
                }
                placement="topCenter"
              >
                <div>
                  <MoreOutlined className="btn-expander" style={{ fontSize: "26px" }} />
                </div>
              </Dropdown>
            );
          },
        },
        { label: this.props.t("document_name"), key: "Name" },
        { label: this.props.t("document_category"), key: "Description" },
        { label: this.props.t("created_on"), key: "CreationDateDocument" },
      ],
    };
  }

  componentDidMount = () => {
    this.setState(
      {
        order: this.props.order,
        data: this.props.data,
      },
      () => {
        this.getComments();
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        data: nextProps.data,
      },
      () => this.getComments()
    );
  };

  delDoc = (value) =>
    (value.CreateBy === "API" && this.props.rolId === "1") ||
      (value.CreateBy === "API" && this.props.rolId === "6") ? (
      <a
        className="fas fa-trash-alt fa-2x"
        onClick={() => this.rmDocument(value)}
      ></a>
    ) : (
      <></>
    );

  getComments = async () => {
    let { id } = this.state;
    let url = `${Services.ORDEN_SERV.path}orderDocument/search/${id}?userId=${this.props._user
      }&moduleId=${10}`;

    let success = await Axios.get(url);
    if (success.data && success.data.data) {
      const documents = success.data.data;

      this.setState({
        data: documents.filter((doc) => doc.Deleted === "0"),
      });
    }
  };

  toggle = (evt) => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  callback = (success) => {
    this.setState(
      (prevState) => ({
        modal: !prevState.modal,
      }),
      () => this.getComments()
    );
  };

  onError = (error) => {
    this.setState(
      (prevState) => ({
        modal: !prevState.modal,
      }),
      () => this.getComments()
    );
  };

  rmDocument = (value) => {
    this.setState({
      openDeleteModal: true,
      modalValue: value,
      nameDoc: value.Name,
    });
  };

  toggleDeleteModal = (evt) => {
    this.setState((prevState) => ({
      openDeleteModal: !prevState.openDeleteModal,
    }));
  };

  removeDocumentModal = async () => {
    let values = this.state.modalValue;
    let url = `${Services.ORDEN_SERV.path}orderDocument/delete/`;

    await Axios.post(url, values).then((success) => {
      if (success.data.code === 200) {
        this.setState({ openDeleteModal: false }, () => this.getComments());
      } else {
        console.error("No se pudo eliminar el documento");
      }
    });
  };

  render() {
    let { modal, openDeleteModal } = this.state

    return (
      <>
        <Card className="myCard">
          <CardBody>
            <div className="row">
              <div className="col-12">
                <Table
                  columns={this.state.columns}
                  data={this.state.data}
                  itemsByPage={10}
                  options={{
                    large: false,
                    downloads: {
                      pdf: false,
                      xlsx: false,
                    },
                    pagination: true,
                    search: false,
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-11"></div>
              <div className="col-1">
                {
                  ![71].includes(this.props.poInfo.StatusId ?? this.props.poInfo.StatusIdPS) ? (
                    <Button
                      color="primary"
                      onClick={this.toggle}
                    >
                      <span className="icon-plus icon-button-add no-margin" />
                    </Button>
                  ) : false
                }
              </div>
            </div>
          </CardBody>
        </Card >

        {createModal({
          isModalOpen: modal,
          titleModal: this.props.t("create_new_document"),
          component: <AddComment callback={this.callback} onError={this.onError} id={this.state.id} _user={this.props._user} onCancel={this.toggle} />,
          onCancel: this.toggle,
          width: '500px',
          destroyOnClose: true
        })}

        {createModal({
          isModalOpen: openDeleteModal,
          titleModal: this.props.t("delete_document"),
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("are_sure_delete_document", { docname: this.state.nameDoc })}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("cancel"),
              onClick: this.toggleDeleteModal,
              type: "secondary",
            },
            {
              text: this.props.t("yes"),
              onClick: this.removeDocumentModal,
              type: "primary",
            },
          ],
          onCancel: this.toggleDeleteModal
        })}
      </>
    );
  }
}

export default withNamespaces()(withRouter(Tracking));
